<!-- Reviews Statistics -->
<div class="reviews-statistics">
    <div class="row align-items-center">
        <div class="col-md-3 text-center mb-4 mb-md-0">
            <h2 class="display-4 text-black fw-bold mb-0">{{ this.reviewBreakDown?.averageRating | number:'1.1-1' }}</h2>
            <div class="d-flex justify-content-center my-2">
                <ng-container *ngFor="let star of [1,2,3,4,5]">
                    <svg [class.bi-star]="star > this.reviewBreakDown?.averageRating" [class.bi-star-fill]="star <= this.reviewBreakDown?.averageRating"
                        [class.text-warning]="star <= this.reviewBreakDown?.averageRating" xmlns="http://www.w3.org/2000/svg" width="16"
                        height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path
                            d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                </ng-container>
            </div>
            <p class="text-muted mb-0">{{ totalResults }} reviews</p>
        </div>
        <div class="col-md-9">
            <div class="row align-items-center mb-2" *ngFor="let stat of ratingStats">
                <div class="col-2">{{ stat.rating }} stars</div>
                <div class="col">
                  <div class="progress">
                    <div class="progress-bar bg-warning" [style.width.%]="stat.percentage"></div>
                  </div>
                </div>
                <div class="col-2 text-end">{{ stat.percentage }}%</div>
              </div>
        </div>
    </div>
</div>

<!-- Reviews List -->
<div class="row">
    <div class="col-12" *ngFor="let review of reviews">
        <div class="reviews-statistics mb-3">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="d-flex">
                        <div class="first_letter heading_24 me-3">
                            {{review?.customerName?.length ? review?.customerName[0] :'U'}}
                        </div>
                        <div>
                            <div class="heading_16 mb-2">
                                {{ review.customerName }}
                            </div>
                            <div class="description_14">
                                {{ review.createdAt | date }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-1">
                        <ng-container *ngFor="let star of [1,2,3,4,5]">
                            <svg [class.bi-star]="star > review.rating" [class.bi-star-fill]="star <= review.rating"
                                [class.text-warning]="star <= review.rating" xmlns="http://www.w3.org/2000/svg"
                                width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                <path
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>
                        </ng-container>
                    </div>
                </div>
                <h5 class="heading_18 mb-2">{{ review.reviewTitle }}</h5>
                <p class="description_16-2">{{ review.comment }}</p>

                <div class="d-flex gap-2 flex-wrap" *ngIf="review.imageUrl.length">
                    <img *ngFor="let image of review.imageUrl; let i = index" [src]="image" class="image-preview"
                        (click)="openImageModal(review.imageUrl, i)">
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #imageModalTemplate>
    <div class="modal d-block" tabindex="-1" style="z-index:1050;" (click)="closeImageModal()">
        <div class="modal-dialog modal-dialog-centered modal-lg" (click)="$event.stopPropagation()">
            <div class="modal-content bg-dark text-white d-flex align-items-center justify-content-center position-relative"
                style="height: 80vh;">
                <button class="btn-close bg-white border-4 p-2 z-3 position-absolute top-0 end-0 m-3" aria-label="Close"
                    (click)="closeImageModal()"></button>
                <div class="modal-body d-flex justify-content-center text-center w-100">
                    <div class="d-flex align-items-center justify-content-center">
                        <img [src]="currentImage" class="img-fluid" />
                    </div>
                    <div class="d-flex justify-content-between mt-3">
                        <button class="btn btn-light position-absolute top-50" style="left: 15px;"
                            (click)="prevImage()" [disabled]="currentIndex === 0">←</button>
                        <button class="btn btn-light position-absolute top-50" style="right: 15px;" (click)="nextImage()"
                            [disabled]="currentIndex === imageList.length - 1">→</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Trigger to open the modal -->
<ng-container *ngIf="showImageModal">
    <ng-container *ngTemplateOutlet="imageModalTemplate"></ng-container>
</ng-container>